module.exports = __webpack_public_path__ + "static/img/case1.1430d225.png";